module.exports = __webpack_public_path__ + "img/pos.e19cb329.jpg";